module.exports = "/static/media/payment_logo--paypal.b5425c82.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/payment_logo--paypal.svg
// module id = 1724
// module chunks = 0